<template>
  <div>
    <div style="display: flex; flex-direction: row">
      <span>
        <v-btn text icon color="black" v-on:click="caricaDati">
          <v-icon>refresh</v-icon>
        </v-btn>
      </span>

      <span>
        <v-row class="ma-0 pa-0 mb-2 mt-2">
          <v-switch v-model="swFatturato" label="Filtra per fatturato" class="pl-3 pb-2 mt-1" hide-details
            color="primary" v-on:change="cambiaFiltro" />

          <v-checkbox v-if="role == 'Admin'" v-model="mieiClienti" label="Vedi solo i miei clienti"
            class="pl-3 pb-2 mt-1" hide-details color="primary" v-on:change="cambiaFiltro" />
        </v-row>

        <v-flex xs6 sm6>
          <v-select return-object outlined label="Tipologia" no-data-text="Nessun dato" :items="tipi" v-model="tipo"
            item-text="text" v-on:input="cambiaTipologia()" style="width: 150px; max-width: 150px">
            <template v-slot:item="{ item }">
              <template>
                <v-list class="ma-0 pa-0">
                  <v-row no-gutters class="ma-0 pa-0">
                    <v-col cols="12" class="ma-0 pa-0">
                      <v-list-item class="ma-0 pa-0">
                        <img :src="item.image" style="max-width: 28px" class="mr-3" />
                        <span>{{ item.text }}</span>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list>
              </template>
            </template>
          </v-select>
        </v-flex>
      </span>

      <span v-if="swFatturato">
        <div style="margin-bottom: 0px; margin-top: 12px; font-size: 0.9em; padding-top: 10px;">
          (Il fatturato è stato generato dagli ordini consegnati negli ultimi 12 mesi)
        </div>
      </span>
      <v-spacer />

      <v-text-field append-icon="search" label="Cerca indirizzo" class="mt-0" single-line hide-details
        v-model="indirizzo" clearable style="min-width: 40%; margin-bottom: -5px; padding-bottom: -5px"
        @click:append="cerca()" v-on:keyup.enter="cerca()" />
    </div>

    <div>
      <div style="width: 100%; height: 100%">
        <div class="google-map mb-15" :id="mapName"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { get_mapsClienti /* get_mapsProvince */ } from "@/api/api.agenti.js";
/* import { geoxml3 } from "@/assets/lib/geoxml3-master/kmz/geoxml3.js"; */
import mixinMaps from "@/mixin/mixinMaps.js"

/**
 * https://sites.google.com/site/gmapsdevelopment/
 */
export default {
  name: "google-map",

  mixins: [mixinMaps],

  props: {
    name: {
      type: String,
      default: "",
    },
  },

  data: function () {
    return {
      mapName: "google-map",
      inputAddress: "pac-input",
      markerCoordinates: [],
      map: null,
      bounds: null,
      infoWindow: null,
      markers: [],
      markersYou: [],
      indirizzo: "",
      markerColor: "",
      showroomMColor:
        this.$load.getUrlImg() + "\\mappe\\pointers\\showroom.png",
      clientiMColor: this.$load.getUrlImg() + "\\mappe\\pointers\\cliente.png",
      image: {
        url: this.$load.getUrlImg() + "\\mappe\\pointers\\utente.png",
        size: null,
      },
      tipi: this.getTipiInit(),
      tipo: { text: "tutti", value: "tutti", image: "" },
      styles: this.returnStyle(),

      swFatturato: false,
      autocomplete: null,
      mieiClienti: false,
    };
  },

  methods: {

    async caricaMappa() {
      const clearMarkers = (arr) => {
        arr.forEach((m) => m.setMap(null));
        return [];
      };

      this.markers = clearMarkers(this.markers);
      this.markersYou = clearMarkers(this.markersYou);

      // -------------------------------------------------------------
      // Inizializzazione mappa (solo la prima volta)
      // -------------------------------------------------------------
      if (!this.map) {
        // eslint-disable-next-line no-undef
        this.bounds = new google.maps.LatLngBounds();
        // eslint-disable-next-line no-undef
        this.infoWindow = new google.maps.InfoWindow();

        const element = document.getElementById(this.mapName);

        // eslint-disable-next-line no-undef
        this.map = new google.maps.Map(element, {
          componentRestrictions: { country: "it" },
          mapTypeId: "roadmap",
          styles: this.styles,
          minZoom: 5,
          maxZoom: 20,
          zoom: 6,
        });
      }

      let tipoSel =
        this.tipo.value === "showroom"
          ? 1 //showroom
          : this.tipo.value === "clienti"
            ? 0 //clienti
            : 2;  //tutti
      if (this.tipo.value.startsWith("p_")) {
        tipoSel = -1;
      }

      // -------------------------------------------------------------
      // Funzione di selezione icona marker
      // -------------------------------------------------------------
      const base = this.$load.getUrlImg() + "\\mappe\\pointers\\";

      const getIcon = (c) => {
        if (!this.swFatturato) {
          if (!c.Potenziale)
            return c.Esposizione === 0
              ? this.clientiMColor
              : this.showroomMColor;
          else {
            return `${base}${c.NomeFile}`;
          }
        }

        const fasce = [
          { max: 5000, col: "rosso" },
          { max: 15000, col: "giallo" },
          { max: Infinity, col: "verde" },
        ];

        const fascia = fasce.find((f) => c.Fatturato <= f.max);
        const tipo = c.Esposizione === 1 ? "showroom" : "cliente";

        return `${base}${tipo}-${fascia.col}.png`;
      };

      // -------------------------------------------------------------
      // Render markers
      // -------------------------------------------------------------
      let visible = false;
      for (let coord of this.markerCoordinates) {
        if (!coord) continue;

        // filtro showroom / clienti
        if (tipoSel >= 0) {
          if (tipoSel !== 2 && tipoSel !== coord.Esposizione) continue;
          if (coord.Potenziale) continue;
        }
        if ((tipoSel < 0 && !coord.Potenziale)) continue;
        if (tipoSel < 0 && (this.mieiClienti && coord.ClCodCli != this.codice)) continue;

        // filtro colore selezionato
        let icon = getIcon(coord);
        visible = false;
        if (this.swFatturato) {
          // FILTRO per colore selezionato dall’utente
          let col = icon.includes("rosso")
            ? "rosso"
            : icon.includes("giallo")
              ? "giallo"
              : "verde";

          visible = this.tipo.value === "tutti" || this.tipo.value === col;
        } else {
          visible = true;
        }

        if (tipoSel < 0 && this.tipo.value != "p_tutti") {
          if (this.tipo.image.includes(coord.NomeFile) && this.tipo.value != "")
            visible = true;
          else visible = false;
        }

        if (!visible) continue;

        // -----------------------------------------------------------
        // Crea marker
        // -----------------------------------------------------------
        // eslint-disable-next-line no-undef
        let position = new google.maps.LatLng(coord.Latitudine, coord.Longitudine);

        // eslint-disable-next-line no-undef
        const marker = new google.maps.Marker({
          position,
          map: this.map,
          icon: { url: icon },
        });

        this.bounds.extend(position);
        this.map.fitBounds(this.bounds);

        marker.addListener("click", async () => {
          let msg = coord.ClRagSoc;

          if (this.swFatturato) {
            msg += `<br> Fatturato: €${coord.Fatturato}`;

            let res = await get_mapsClienti(`dettaglio/${coord.ClCodCli}`);
            if (res.data) {
              let d = res.data;
              msg += `
            <div>
              <hr>
              MPM Porte: €${d.MpmPorte}
              <br>MPM Arredo: €${d.MpmArredo}
              <br>MPM Sicur: €${d.MpmSicur}
              <hr>Agente: ${coord.NomeAgente}
            </div>`;
            }
          } else if (tipoSel < 0) {
            msg += `
            <div>
              <hr>
              Tipo: ${coord.NomeFile.replace(".png", "")}
            </div>`;
          }

          this.infoWindow.setContent(msg);
          this.infoWindow.open(this.map, marker);
        });

        this.markers.push(marker);
      }
    },

    async caricaDati() {
      // Reset
      this.markerCoordinates = [];

      let par = "";
      let userSwitch = this.$store.getters["user/getUserSwitch"];
      if (userSwitch.Codice) par = userSwitch.Tipo + "/" + userSwitch.Codice;
      /* else if (this.$store.getters["user/getCodice"])
        par = "agente" + "/" + this.$store.getters["user/getCodice"]; */

      let res = await get_mapsClienti(par);
      if (res == null || this.markerCoordinates == undefined) return;
      this.markerCoordinates = res.data;
      this.caricaMappa();
      this.map.setZoom(6);
      await this.centerMapItaly();
    },

    cerca() {
      for (let i = 0; i < this.markersYou.length; i++) {
        this.markersYou[i].setMap(null);
      }
      this.markersYou = [];

      var markerYou = null;
      // eslint-disable-next-line no-undef
      var geocoder = new google.maps.Geocoder();
      const self = this;
      geocoder.geocode({ address: self.indirizzo }, function (results, status) {
        // eslint-disable-next-line no-undef
        if (status == google.maps.GeocoderStatus.OK) {
          var center = results[0].geometry.location;
          // eslint-disable-next-line no-undef
          self.image.size = new google.maps.Size(60, 96);
          // eslint-disable-next-line no-undef
          markerYou = new google.maps.Marker({
            map: self.map,
            icon: self.image,
            position: center,
          });

          self.markersYou.push(markerYou);
          self.map.setZoom(15);
          self.map.panTo(center);

          // eslint-disable-next-line no-undef
          google.maps.event.addListener(markerYou, "click", function () {
            self.infoWindow.setContent("<b>LOCALITÀ SELEZIONATA</b>");
            self.infoWindow.open(this.map, markerYou);
          });
        } else {
          self.$toast.warning(self.indirizzo + "\n località non trovata");
        }
      });
    },

    async cambiaFiltro() {
      let base = this.$load.getUrlImg() + "\\mappe\\pointers\\";

      if (this.swFatturato) {
        this.tipo = { text: "tutti", value: "tutti", image: "" };

        this.tipi = [
          this.tipo, // il default sempre presente
          ...this.getTipiFatturato(base),
        ];
      } else {
        this.tipi = [...this.getTipiInit(base)];
      }

      await this.caricaMappa();
      await this.centerMapItaly();
    },

    async cambiaTipologia() {
      await this.caricaMappa();
      await this.centerMapItaly();
    },

    async centerMapItaly() {
      await this.map.panTo(
        // eslint-disable-next-line no-undef
        new google.maps.LatLng(42.403516412008976, 11.1472753585981)
      );
      await this.map.setZoom(6);
    },
  },

  async mounted() {
    //aspetto qualche millisecondo cosi vue carica i dati dell'utente nello storage
    await this.$functions.delay(500);

    await this.caricaDati();
    //visualizzo la mappa con l'Italia centrata
  },

  computed: {
    userSwitch: function () {
      return this.$store.getters["user/getUserSwitch"];
    },
    codice: function () {
      return this.$store.getters["user/getIdUtente"];
    },

    role: function () {
      return this.$store.getters["user/getRole"];
    },

  },

  watch: {
    userSwitch() {
      this.caricaDati();
    },
  },
};
</script>

<style scoped>
.google-map {
  width: 100%;
  height: 1000px;
  margin: 0 auto;
  background: gray;
  color: black;
}
</style>